<template>
  <div>
    <b-button size="sm" variant="secondary" class="mb-2 mr-2" @click="cancel">
        <b-icon icon="arrow-left"></b-icon>Cancel</b-button>
    <div class="row">
      <div class="col-md-6">
        <b-form-group>
          <b-form-input required
            :state="titleValidation"
            v-model="image.title" placeholder="Title"
            class="form-control"
            invalid-feedback="Title is required"></b-form-input>
          <span class="text-danger">*</span> <span class="text-muted">Required</span>
        </b-form-group>
      </div>
    </div>
    <h3>Card image</h3>
    <DropzoneContainer
      ref="dropzone"
      :options="dropzoneOptions"
      :uploadOnAdd="false"
      @file-added="fileAdded"
      @upload-success="uploadSuccess"
      @upload-error="uploadError">
    </DropzoneContainer>
    <div class="my-3" v-if="file && file.accepted">
      <b-button variant="success" @click="submit" :disabled="!file.accepted">Save image</b-button>
      <span class="text-danger" v-if="!file.accepted">There's an error with the image.</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import DropzoneContainer from '../../components/DropzoneContainer.vue';

export default {
  components: { DropzoneContainer },

  props: {
    position: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      formSubmitted: false,
      image: { title: '', image: null },
      dropzoneOptions: {
        acceptedFiles: '.jpg,.jpeg,.png,.gif',
        resizeWidth: 400,
        resizeMimeType: 'image/jpeg',
      },
      file: null,
    };
  },

  computed: {
    ...mapState(['directUploadUrl']),

    titleValidation() {
      if (!this.formSubmitted) {
        return null;
      }
      return this.image.title.length !== 0;
    },
  },

  methods: {
    ...mapMutations(['addRevealImage']),

    cancel() {
      this.$emit('cancel');
    },

    createRevealImage() {
      axios.post('/api/v2/reveal-images', {
        reveal_image: this.image,
      }).then((response) => {
        if (response.status === 201) {
          this.$toast.open('Image uploaded and added to your schedule!');
          const { id, image, title } = response.data.reveal_image;
          const newImage = {
            reveal_image_id: id, image, title, position: this.position,
          };
          this.addRevealImage(newImage);
          this.$refs.dropzone.reset();
          this.file = null;
          this.image = {
            title: null,
            image: null,
          };
          this.$emit('image-created');
        }
      });
    },

    fileAdded(file) {
      this.file = file;
    },

    submit() {
      this.formSubmitted = true;
      if (this.titleValidation) this.$refs.dropzone.upload();
    },

    uploadSuccess({ blob }) {
      this.image.blob = blob;
      this.image.image = blob.signed_id;
      this.createRevealImage();
    },

    uploadError() {
      this.$toast.open({
        type: 'error',
        message: 'The image could not be uploaded. Please try again',
      });
    },
  },
};
</script>
